import produce from 'immer';
import { Reducer } from 'redux';
import { remove, sortBy, sortedIndexBy, uniqBy } from 'lodash';

import { ChatSchedule, ChatScheduleState, ChatScheduleTypes, DateRange } from '../types';
import { getScheduleIndexesForRange, idIteratee, scheduleIteratee } from '../utils';

const initialState: ChatScheduleState = {
    isLoading: false,
    isSaving: false,
    chatSchedules: [],
};

const chatScheduleReducer: Reducer<ChatScheduleState> = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case ChatScheduleTypes.GET_SCHEDULES:
                const { schedules, range } = action.payload;
                draft.chatSchedules = updateScheduleRange(draft.chatSchedules, schedules, range);
                break;
            case ChatScheduleTypes.UPSERT_SCHEDULE:
                const schedule = action.payload;
                updateSchedule(draft.chatSchedules, schedule);
                draft.isSaving = false;
                break;
            case ChatScheduleTypes.DELETE_SCHEDULE:
                remove(draft.chatSchedules, (s) => s.id === action.payload);
                draft.isSaving = false;
                break;
            case ChatScheduleTypes.REQUEST_ADD_SCHEDULE:
            case ChatScheduleTypes.REQUEST_UPDATE_SCHEDULE:
            case ChatScheduleTypes.REQUEST_DELETE_SCHEDULE:
                draft.isSaving = true;
                draft.error = undefined;
                break;
            case ChatScheduleTypes.SCHEDULE_ERROR_SAVING:
                draft.error = action.payload.error;
                draft.isSaving = false;
                break;
            case ChatScheduleTypes.SCHEDULE_ERROR_LOADING:
                draft.error = action.payload.error;
                draft.isLoading = false;
                break;
            case ChatScheduleTypes.CLEAR_SCHEDULE_ERROR:
                draft.error = undefined;
                break;
            default: {
                return draft;
            }
        }
    });
};

function updateScheduleRange(sortedSchedules: ChatSchedule[], newSchedules: ChatSchedule[], range: DateRange) {
    const [startIdx, endIdx] = getScheduleIndexesForRange(sortedSchedules, range);
    const merged = uniqBy(
        [...newSchedules, ...sortedSchedules.slice(0, startIdx), ...sortedSchedules.slice(endIdx)],
        idIteratee,
    );
    return sortBy(merged, scheduleIteratee);
}

export function updateSchedule(sortedSchedules: ChatSchedule[], item: ChatSchedule) {
    remove(sortedSchedules, (s) => s.id === item.id);
    const idx = sortedIndexBy(sortedSchedules, item, scheduleIteratee);
    sortedSchedules.splice(idx, 0, item);
}

export { chatScheduleReducer };
